export default __webpack_public_path__ + "static/media/2.2b2cef77.jpg";